<template>
  <ContainerWrapper>
    <OffersList
      v-if="cptdHasNoCollateralOffers || cptdDisplayAffiliates"
      title="Sem garantia"
      :offer-list="cptdNoCollateralOffers"
    >
      <JBCredOfferCardContainer v-if="cptdDisplayJbcred" key="JBCRED" />
      <DeuTopOfferCardContainer v-if="cptdDisplayDeutop" key="DEUTOP" />
      <ZippiOfferCardContainer v-if="cptdDisplayZippi" key="ZIPPI" />
    </OffersList>
    <OffersList
      v-if="cptdHasMobileEquityOffers"
      title="Com celular em garantia"
      :offer-list="cptdMobileEquityOffers"
    >
    </OffersList>
    <NoCollateralNoResultFeedbackDialogContainer
      v-if="displayNoResultFeedbackDialog"
      :display="displayNoResultFeedbackDialog"
      @close="displayNoResultFeedbackDialog = false"
    />
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import { Partner } from '@/data/common'
import JBCredOfferCardContainer from '@/containers/loans/no-collateral/offer/affiliates/jbcred/JBCredOfferCardContainer.vue'
import NoCollateralNoResultFeedbackDialogContainer from '@/containers/forms/loans/no-collateral/NoCollateralNoResultFeedbackDialogContainer.vue'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import { getNoCollateralAffiliates } from '@/helpers/loans/no-collateral/affiliates'
import DeuTopOfferCardContainer from '~/containers/loans/no-collateral/offer/affiliates/deutop/DeuTopOfferCardContainer.vue'
import { abTest } from '~/helpers/abTest'
import ZippiOfferCardContainer from '~/containers/loans/no-collateral/offer/affiliates/zippi/ZippiOfferCardContainer.vue'

export default {
  name: 'NoCollateralOffersListContainer',
  components: {
    ZippiOfferCardContainer,
    DeuTopOfferCardContainer,
    JBCredOfferCardContainer,
    NoCollateralNoResultFeedbackDialogContainer,
    ContainerWrapper,
    OffersList,
  },
  data() {
    return {
      displayNoResultFeedbackDialog: false,
      displayMobileEquitySection: false,
    }
  },
  computed: {
    ...mapGetters({
      personaData: 'user/persona/personaData',
      gtCreditScoreLatest:
        'products/credit-score/credit-score/gtCreditScoreLatest',
      gtAllProposedNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllProposedNoCollateralOffers',
      gtAllOnGoingNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllOnGoingNoCollateralOffers',
      gtAllGrantedNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllGrantedNoCollateralOffers',
      gtNoCollateralLatestSimulationRequest:
        'products/loans/no-collateral/no-collateral/gtNoCollateralLatestSimulationRequest',
    }),
    cptdHasProposedOffers() {
      return this.gtAllProposedNoCollateralOffers.length > 0
    },
    cptdIsGroupB() {
      return abTest() === 'B'
    },
    cptdMobileEquityOffers() {
      if (this.displayMobileEquitySection && this.cptdIsGroupB) {
        return this.gtAllProposedNoCollateralOffers.filter(
          (o) => o.partner === Partner.JUVO,
        )
      }
      return []
    },
    cptdHasMobileEquityOffers() {
      return (
        this.displayMobileEquitySection &&
        this.cptdIsGroupB &&
        this.cptdMobileEquityOffers.length > 0
      )
    },
    cptdNoCollateralOffers() {
      if (this.displayMobileEquitySection && this.cptdIsGroupB) {
        return this.gtAllProposedNoCollateralOffers.filter(
          (o) => o.partner !== Partner.JUVO,
        )
      }
      return this.gtAllProposedNoCollateralOffers
    },
    cptdHasNoCollateralOffers() {
      return this.cptdNoCollateralOffers.length > 0
    },
    cptdAvailableAffiliates() {
      if (
        Object.keys(this.personaData || {}).length > 0 &&
        this.gtCreditScoreLatest?.data?.score
      ) {
        return getNoCollateralAffiliates(
          this.gtAllProposedNoCollateralOffers,
          this.personaData,
          this.gtCreditScoreLatest.data.score,
        )
      }
      return {}
    },
    cptdDisplayAffiliates() {
      return (
        this.cptdDisplayJbcred ||
        this.cptdDisplayZippi ||
        this.cptdDisplayDeutop
      )
    },
    cptdDisplayJbcred() {
      return this.cptdAvailableAffiliates[Partner.JBCRED]
    },
    cptdDisplayDeutop() {
      return this.cptdAvailableAffiliates[Partner.DEUTOP]
    },
    cptdDisplayZippi() {
      return this.cptdAvailableAffiliates[Partner.ZIPPI]
    },
    cptdEmptyStateOffers() {
      return [
        {
          amount: 5000,
          duration: 36,
          interestRate: 4.2,
        },
        {
          amount: 3000,
          duration: 36,
          interestRate: 4.2,
        },
        {
          amount: 500,
          duration: 36,
          interestRate: 4.2,
        },
      ]
    },
  },
  mounted() {
    this.checkLastSimulationResult()
  },
  methods: {
    checkLastSimulationResult() {
      const { last_product_simulation } = this.$route?.query || {}
      this.displayNoResultFeedbackDialog =
        last_product_simulation === 'no-collateral' &&
        !this.cptdHasProposedOffers &&
        !this.cptdDisplayAffiliates
    },
  },
}
</script>
<style lang="scss"></style>
